import { Outlet } from 'react-router-dom';

import { AcadlyPage } from '../db/shared/types';
import { usePageManager } from '../pages/hooks';

const useUniversity = () => {
  usePageManager(AcadlyPage.UNIVERSITY, {
    setPageReadyWhenParentIsReady: true,
  });
};

const University = () => {
  useUniversity();
  return <Outlet />;
};

export default University;
